export const dropPartialItem = (countValue) => (args, d) => d.datapoints?.length === countValue;
